import(/* webpackMode: "eager" */ "E:\\Workstation\\Work\\develop\\code\\ethereum\\presale\\layerbrett\\layerbrett_frontend\\src\\app\\page.tsx");
